import { FunctionComponent } from "react";

import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { Icon } from "@/components";
import { BrandsIcon } from "@/components/BrandsIcon/BrandsIcon";

import { CardChannel } from "./lead-card-compact.helper";

/** The compact card's gutter badge for the lead's outreach channel; nothing when there is none. */
export const CardChannelBadge: FunctionComponent<{ channel: CardChannel | null }> = ({
	channel,
}) => {
	if (channel === "linkedin") {
		return (
			<span
				className="w-6 h-6 rounded-full bg-blue-action-200 text-blue-action flex items-center justify-center"
				data-testid="card-channel-linkedin"
			>
				<BrandsIcon className="w-3 h-3" icon={faLinkedinIn} />
			</span>
		);
	}

	if (channel === "email") {
		return (
			<span
				className="w-6 h-6 rounded-full bg-status-info-light text-status-info flex items-center justify-center"
				data-testid="card-channel-email"
			>
				<Icon className="w-3 h-3" icon={faEnvelope} />
			</span>
		);
	}

	return null;
};
